<template>
	<div class="voo-block">
		<div class="voo-card card-footer">
			<div class="voo-box-img-footer">
				<img :src="require('@/assets/footer_key.webp')" />
			</div>
			<div class="voo-wrap">
				<div class="voo-colum card-info">
					<div class="voo-subtitle pb-5">VOOWE</div>
					<div class="voo-text">г. Владивосток ул. Шилкинская 11</div>
					<div class="voo-text">voowecode@gmail.com</div>
					<div class="voo-text">8 953 205 00 14</div>
					<div class="voo-text">Время работы:<span class="text-gray pl-2"> пн-пт с 10:00 до 19:00</span></div>
				</div>
				<div class="voo-colum card-main">
					<div class="voo-subtitle pb-5">ПОЛУЧИТЬ КОНСУЛЬТАЦИЮ</div>
					<div class="voo-text text-gray">Проведем встречу в формате ВКС или <br />телефонного звонка предложим варианты и <br />сформируем коммерческое предложение</div>
					<div class="pt-2"><v-btn variant="flat" color="#404040" class="voo-btn text-none" @click="goTo('/order')">ЗАЯВКА</v-btn></div>
				</div>
			</div>
			<div class="voo-wrap ip pt-5">
				<div class="voo-subtitle pb-5 text-gray">ИП ГРИБАНОВ ГЛЕБ</div>
			</div>
			<div class="line"></div>
			<div class="voo-wrap pt-5">
				<div class="voo-row">
					<div class="voo-text text-gray">Реквизиты</div>
					<div class="voo-text text-gray">Политика конфиденциальности</div>
				</div>
				<div class="voo-row item-end">
					<div class="voo-text text-gray">Вконтакте</div>
					<div class="voo-text text-gray">Telegram</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		methods: {
			goTo(path) {
				this.show = false;
				this.$router.push(path);
			},
		},
	};
</script>
<style scoped>
	@media screen and (max-width: 768px) {
		.card-footer {
			padding: 20px;
		}
		.voo-box-img-footer {
			max-width: 250px;
		}
	}

	.card-footer {
		border-radius: 30px 30px 0px 0px ;
		padding: 50px;
	}

	.card-main {
		flex: 8 1 300px !important;
		gap: 10px !important;
	}

	.card-info {
		flex: 4 1 200px !important;
		gap: 10px !important;
	}

	.text-gray {
		color: #737373 !important;
	}

	.ip {
		justify-content: end;
	}

	.voo-box-img-footer {
		position: absolute;
		top: 0px;
		right: 0px;
		width: 100%;
		max-width: 350px;
		z-index: 0;
	}

	.voo-box-img-footer img {
		object-fit: cover;
		width: 100%;
		height: 100%;
	}

	.line {
		width: 100%;
		height: 2px;
		background-color: #737373;
		display: flex;
	}
</style>
